module.exports = __webpack_public_path__ + "static/media/ta-grad-03.d7780768.png";